// extracted by mini-css-extract-plugin
module.exports = {"descriptionContainer":"Description_descriptionContainer__CAFwg","categoryImage":"Description_categoryImage__nj0mh","statisticsContainer":"Description_statisticsContainer__yBbJd"};